import { GET_ACTIVE_USERS } from 'actions/Types';

export default (state = null, action) => {
  if (action.type === `${GET_ACTIVE_USERS}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
